const ITEMS = [
  "Creative Technology",
  "Digital Experiences",
  "3D Spatial Architecture",
  "Kinetic Design",
  "Generative Futures",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-white/10 bg-[#0B0C10]/70 py-7 backdrop-blur-sm"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="font-display px-10 text-lg font-light uppercase tracking-[0.3em] text-[#F4F6FB]/60 md:text-2xl">
                  {item}
                </span>
                <span className="text-sm text-[#D4AF37]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
